import { AbstractControl } from '@angular/forms';

export function BudgetStodgrundRequired(stodgrundWithParagrafer: string[]) {
  return (control: AbstractControl) => {
    if (control.value) {
      const parsedValue = JSON.parse(control.value);
      const noMissingStodgrund = !parsedValue.projektparter.some(
        (p) =>
          p.bidragPerAr.some((bidrag) => bidrag.summa > 0) &&
          (!p.stodgrund?.varde ||
            stodgrundWithParagrafer.includes(p.stodgrund?.varde)),
      );
      if (noMissingStodgrund) {
        return;
      }
    }

    return { StodgrundRequired: true };
  };
}
